import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import 'normalize.css'
import '@/assets/css/base.css' 
import '@/assets/css/amaps.css' 
import axios from './utils/axios.js'; // 导入封装好的axios实例

Vue.prototype.$axios = axios; // 将axios实例添加到Vue的原型链上

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
 